import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// // Basic hardening to discourage downloading/saving
// document.addEventListener("contextmenu", (e) => e.preventDefault());
// document.addEventListener("dragstart", (e) => e.preventDefault());
// document.addEventListener(
//   "keydown",
//   (e) => {
//     // Block common save/download shortcuts
//     if (
//       (e.ctrlKey || e.metaKey) &&
//       (e.key.toLowerCase() === "s" || e.key.toLowerCase() === "p")
//     ) {
//       e.preventDefault();
//     }
//   },
//   { passive: false }
// );

const gtagId = process.env.REACT_APP_GTAG_ID;

if (gtagId) {
  const script1 = document.createElement("script");
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
  document.head.appendChild(script1);

  const script2 = document.createElement("script");
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
    gtag('js', new Date());
    gtag('config', '${gtagId}');
  `;
  document.head.appendChild(script2);
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
